import { toYYYYMMDD } from "@/common/utilities/date/toYYYYMMDD";

/**
 * The move-in (private office) or start (virtual office) date the inquiry
 * forms open with: the 1st of next month, as an `<input type="date">` value.
 *
 * Built from the local calendar. Formatting the instant in UTC instead put the
 * default a day early for everyone east of UTC -- the 30th, not the 1st -- and
 * that was the date most leads were submitted with.
 * @param now - Overridable for tests.
 */
export const getDefaultMoveInDate = (now: Date = new Date()) =>
    toYYYYMMDD(new Date(now.getFullYear(), now.getMonth() + 1, 1));
